<div class="startup-content">

  <div class="info">
    <span class="no-select" *ngIf="!hasError">{{ 'startup.info' | translate }}</span>
    <span class="no-select" *ngIf="hasError">{{ 'startup.generalError' | translate }}</span>
  </div>

  <div class="indicator">
    <mat-spinner diameter="20" *ngIf="!hasError"></mat-spinner>
    <mat-icon class="no-select" *ngIf="hasError">error_outline</mat-icon>
  </div>

  <div class="current-message">
    <span class="no-select">{{ translateableMessage | translate }}</span>
  </div>

  <div *ngIf="hasError" class="error-message">
    <p class="no-select">{{ 'startup.error.' + error.code | translate }}</p>
    <p class="original-error">{{ error.humanMessage }}</p>
  </div>
</div>
